import {
  IAttributeDefinition,
  WSDataTypes
} from "@wingspanhq/payments/dist/interfaces";
import { FieldBoolean } from "./FieldBoolean";
import { FieldDatetime } from "./FieldDatetime";
import { FieldEnum } from "./FieldEnum";
import { FieldNumber } from "./FieldNumber";
import { FieldString } from "./FieldString";
import { AcceptedValuesResources } from "./helpers";

type Props = {
  attributeDefinitions: IAttributeDefinition[];
  resources: AcceptedValuesResources;
  disabled?: boolean;
};

export const FormPartialAttributes: React.FC<Props> = props => {
  return (
    <>
      {props.attributeDefinitions.map(definition => (
        <Field
          key={definition.key}
          definition={definition}
          resources={props.resources}
          disabled={props.disabled}
        />
      ))}
    </>
  );
};

const Field: React.FC<{
  definition: IAttributeDefinition;
  resources: AcceptedValuesResources;
  disabled?: boolean;
}> = props => {
  switch (props.definition.type) {
    case WSDataTypes.Boolean:
      return (
        <FieldBoolean definition={props.definition} disabled={props.disabled} />
      );
    case WSDataTypes.Number:
      return (
        <FieldNumber definition={props.definition} disabled={props.disabled} />
      );
    case WSDataTypes.Datetime:
      return (
        <FieldDatetime
          definition={props.definition}
          disabled={props.disabled}
        />
      );
    case WSDataTypes.ValueSet:
      return (
        <FieldEnum
          definition={props.definition}
          resources={props.resources}
          disabled={props.disabled}
        />
      );
    case WSDataTypes.String:
    default:
      return (
        <FieldString definition={props.definition} disabled={props.disabled} />
      );
  }
};
